import ModalProvider from "@/common/contexts/Modal.context";
import PermissionsProvider from "@/common/contexts/Permissions.context";
import { UploadProvider } from "@/common/contexts/Upload.context";
import WebSocketProvider from "@/common/contexts/Websocket.context";
import { SideBar } from "@/components";
import { Outlet } from "react-router";

export default function MainLayout() {
  return (
    <WebSocketProvider>
      <PermissionsProvider>
        <UploadProvider>
          <ModalProvider>
            <div className="flex bg-gray-border">
              <SideBar />
              <div className=" w-full h-full overflow-hidden">
                <Outlet />
              </div>
            </div>
          </ModalProvider>
        </UploadProvider>
      </PermissionsProvider>
    </WebSocketProvider>
  );
}
